import { SITE } from "@/config/site";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#1A1030" />
    <rect x="14" y="18" width="26" height="32" rx="6" fill="#E8425F" transform="rotate(-10 27 34)" />
    <rect x="22" y="14" width="26" height="32" rx="6" fill="#6C2BD9" />
    <path d="M35 22l2.4 5.2L43 28l-4.2 3.8L40 37l-5-2.8L30 37l1.2-5.2L27 28l5.6-.8z" fill="#FFD84D" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark />
    <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-ink"}`}>
      {SITE.name}
    </span>
  </div>
);
